export const EVENT_NAME = {
  UNDO: "Selection Removal Undone"
};

export const MODULE = "Bet Modal";
